"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _commonReact = require("@devsta/common-react");

require("../styles/_attachment.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function getIconProps(asset) {
  var status = (0, _lodash.default)(asset, 'assetFiles.ORIGINAL.status');

  if (asset === null) {
    return {
      name: 'corrupt',
      tooltipLabel: 'This asset has been deleted from the Media Library.'
    };
  }

  if (status === 'MISSING') {
    return {
      name: 'faq',
      tooltipLabel: 'This asset could not be found.'
    };
  }

  if (status === 'TRANSCODE_FAILED') {
    return {
      name: 'unsupported',
      tooltipLabel: 'The video type of this asset is not supported'
    };
  }

  if (status === 'ERROR') {
    return {
      name: 'fetcherror',
      tooltipLabel: 'There was a problem loading this asset.'
    };
  }

  return {
    name: 'document',
    tooltipLabel: 'fppbar'
  };
}

function Attachment(_ref) {
  var asset = _ref.asset,
      onRemoveAsset = _ref.onRemoveAsset,
      disabled = _ref.disabled;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "attachment"
  }, asset && 'loadedPercent' in asset && asset.loadedPercent !== 100 ? /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    className: "attachment__percent",
    button: true
  }, "".concat(asset.loadedPercent, "%")) : /*#__PURE__*/_react.default.createElement(_uiKit.Icon, _extends({
    tooltipId: (0, _lodash.default)(asset, 'assetId') || "".concat(Date.now())
  }, getIconProps(asset))), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    className: "attachment__title",
    ellipsisOverflow: true,
    noMargin: true
  }, (0, _lodash.default)(asset, 'title')), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    disabled: disabled,
    type: "TERTIARY",
    prefix: "trash",
    onClick: onRemoveAsset
  }));
}

var _default = (0, _commonReact.withAssetSelector)(Attachment);

exports.default = _default;